<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row >
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="full_name">
                                                {{ $t('label.full_name') }}
                                            </kt-form-label>
                                            <kt-form-control ref="full_name" dir="rtl" name="full_name" id="full_name" v-model="query.full_name"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="marketing_level">
                                                {{ $t('marketing.filter.marketer_level') }}
                                            </kt-form-label>
                                            <kt-form-select size="3" id="marketing_level" class="form-control" name="marketing_level" v-model="query.marketing_level">
                                                <option
                                                        v-for="(marketing_level, index) in marketing_levels"
                                                        v-bind:key="index"
                                                        v-bind:value="marketing_level.value"
                                                        :selected="query.marketing_level === marketing_level.value"
                                                >
                                                    {{ marketing_level.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

import {marketingLevelStr, marketingLevel} from '@/constants/marketingLevel'

export default {
    props: {
        action: {
            default: function (e, query) {},
            required: true,
        }
    },

    data() {
        return {
            marketing_levels: [
                {
                    name: null,
                    value: null
                },
                {
                    name: marketingLevelStr.level_1,
                    value: marketingLevel.level_1,
                },
                {
                    name: marketingLevelStr.level_2,
                    value: marketingLevel.level_2,
                },
                {
                    name: marketingLevelStr.level_3,
                    value: marketingLevel.level_3,
                },
            ],
            query: {},
        }
    },

    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    },
}

</script>

<style>
.trash-btn{
    float: left;
    padding: 0 6px 0 0 !important;
}
</style>